export default __webpack_public_path__ + "static/media/Group 11026.2d3ea85f.png";